export const themeG = {
  name: "紫夜星河",
  colors: {
    bg: "#100E18",
    bgSecondary: "#1A1624",
    text: "#F0ECF8",
    textSecondary: "#B4A8CC",
    textMuted: "#9B8EB2",
    accent: "#9B7AD8",
    accentText: "#100E18",
    accentAlt: "#7C6CB8",
    accentWarm: "#C4A0E8",
    accentOrange: "#B88CD4",
    available: "#7AB86E",
    availableText: "#100E18",
    claimed: "#302840",
    cardBg: "#161222",
    cardBorder: "#2E2840",
    overlay: "rgba(16,14,24,0.8)",
    heroBg: "#100E18",
    heroText: "#F0ECF8",
  },
  fonts: {
    heading: "var(--font-cinzel), 'Noto Serif TC', serif",
    body: "var(--font-noto-sans), sans-serif",
    accent: "var(--font-cinzel), serif",
  },
  radius: { sm: "6px", md: "12px", lg: "18px", full: "9999px" },
  spacing: { cardGap: "20px", sectionGap: "52px", pagePadding: "20px" },
  effects: {
    cardShadow: "0 2px 16px rgba(155,122,216,0.08)",
    cardHoverShadow: "0 4px 24px rgba(155,122,216,0.14)",
    bgTexture: true,
    textureOpacity: 0.02,
  },
};
